export default "__VITE_ASSET__J0POpZEk__"